import { combineReducers } from "redux";

import authReducer from "./authReducer";
import accountsReducer from "./AccountsReducer";
import coursesReducer from "./CoursesReducer";
import programReducer from "./programReducer";
import ibridgeReducer from "./ibridgeReducer";
import assignmentDocumentReducer from "./assignmentDocumentReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  accounts: accountsReducer,
  courses: coursesReducer,
  programs: programReducer,
  ibridge: ibridgeReducer,
  assignmentDocument: assignmentDocumentReducer,
});

export default rootReducer;
